module.exports = __webpack_public_path__ + "static/media/display-1@768.3df6a127.png";